// Default check for Vietnamese phone number firstly, to handle other contry later
export function isValidPhoneNumb(value: string): boolean {
  return /^((\+?84|0)[3|5|7|8|9])+([0-9]{8})$/.test(value);
}
